import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    indicatorRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      minWidth: 140,
    },
    indicatorRowEnv: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      minWidth: 0,
    },
    indicatorTrack: {
      position: 'relative',
      width: 70,
      height: 8,
      borderRadius: 9999,
      background: '#ECEFF3',
      overflow: 'hidden',
    },
    indicatorTrackEnv: {
      position: 'relative',
      width: 60,
      height: 8,
      borderRadius: 9999,
      background: '#ECEFF3',
      overflow: 'hidden',
    },

    indicatorBar: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      borderRadius: 9999,
      transition: 'width 180ms ease',
    },
    indicatorLabel: {
      fontSize: 12,
      fontWeight: 600,
      minWidth: 32,
      marginLeft: 6,
      textAlign: 'start',
      color: palette.darkGray,
    },
    indicatorGreen: { background: palette.status.success },
    indicatorYellow: { background: palette.orange },
    indicatorRed: { background: palette.red },
    indicatorLabelRed: {
      color: palette.amber,
      fontWeight: 700,
    },
    indicatorAmber: {
      backgroundColor: palette.amber,
    },
  });
